import React from 'react'
import Image from '../../../images/buyerpolicies/Retention Of Title.png'

const Retention_of_title = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Retention Of Title</h2>
            <p>You will not own the products and goods unless you pay 100% of the price.</p>
        </div>
      </div>
    </div>
  )
}

export default Retention_of_title
